import { Formik, Form } from "formik";
import React, { useEffect } from "react";
import * as yup from "yup";
import SharedDropdown from "../../components/Shared/SharedDropdown";
import SharedButton from "../../components/Shared/SharedButton";
import SharedInputText from "../../components/Shared/SharedInputText";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import CustomSearchDropdown from "../../components/Shared/CustomSearchDropdown";
import { getCashBankAccounts } from "../../store/slices/AcountsSlice";
import {
  CreateNewInsuranceInvoicePayment,
  filterCompanyInvoiceData,
} from "../../store/slices/InvoicesSlice";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../../components/Shared/PageHeader";
import DatePicker from "../../components/Shared/DatePicker";
import DropdownComponent from "../../components/Shared/DropdownComponent";

export default function RecievePaymentCompanyInvoicePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedEntries = location.state?.selectedEntries || [];
  const filtersPayload = location.state?.filtersPayload || {};

  function convertData(data) {
    return data?.length ? data[0].id : "";
  }
  function convertDataa(data) {
    return data?.length ? data[0].total : "";
  }

  const initialValues = {
    invoice_id: convertData(selectedEntries),
    amount: convertDataa(selectedEntries),
    account_code: "",
    date: "",
    payment_method: "",
  };

  const dispatch = useDispatch();
  const lang = i18next.language;
  const { t } = useTranslation();
  const currentDate = new Date().toISOString().split("T")[0];

  const validationSchema = yup.object().shape({
    date: yup.string().required(t("required")),
    payment_method: yup.string().required(t("required")),
    account_code: yup.number().required(t("required")),
  });

  const paymentOption = [
    { value: "cash", label: lang === "ar" ? "نقدي" : "Cash" },
    { value: "bank", label: lang === "ar" ? "بنك" : "Bank" },
    { value: "mada", label: lang === "ar" ? "مدى" : "MADA" },
    { value: "cheque", label: lang === "ar" ? "يفحص" : "Cheque" },
  ];

  function handleSubmit(values, { resetForm }) {
    dispatch(
      CreateNewInsuranceInvoicePayment({ ...values, type: "insurance" }),
    ).then((res) => {
      if (res?.meta?.requestStatus === "fulfilled") {
        resetForm();
        navigate(-1);
        dispatch(filterCompanyInvoiceData(filtersPayload));
      }
    });
  }

  useEffect(() => {
    dispatch(getCashBankAccounts());
  }, [dispatch]);

  const { cashBankAccounts } = useSelector((state) => state?.acount);
  const { isLoading } = useSelector((state) => state.invoice);

  const listAccountsvalues = cashBankAccounts?.data
    ? Object.entries(cashBankAccounts.data).map(([id, account]) => ({
        id: Number(account?.code),
        name: lang === "ar" ? account.name_ar : account.name_en,
      }))
    : [];

  return (
    <div className="flex flex-col w-full gap-4 max-h-[calc(100vh-150px)]">
      <PageHeader title={t("RecordPayment")} backPath={-1} />

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit} className="space-y-2">
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-2 w-full">
 
              <DatePicker
                label={t("date")}
                name="date"
                placeholder={`${t("enter")} ${t("date")}`}
                max={currentDate}
              />
              <DropdownComponent
                label={t("paymentMethod")}
                placeholder={`${t("select")} ${t("paymentMethod")}`}
                name="payment_method"
                options={paymentOption}
              />
              <CustomSearchDropdown
                label={t("account")}
                name={"account_code"}
                className="!bg-gray-100 !h-[30px] !border-gray-300"
                options={listAccountsvalues}
                placeholder={`${t("select")} ${t("account")}`}
              />
            </div>

            <div className="flex justify-end gap-2">
              <SharedButton
                type="button"
                buttonType="reset"
                icon="pi pi-times"
                label={t("Cancel")}
                className="cancel-btn"
                onClick={() => {
                  navigate(-1);
                  props.resetForm();
                }}
              />
              <SharedButton
                type="submit"
                icon="pi pi-check"
                label={t("Submit")}
                className="submit-btn"
                loading={isLoading}
                disabled={isLoading}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
